import { render, staticRenderFns } from "./ModuleDescription.vue?vue&type=template&id=e198eb68&scoped=true&"
import script from "./ModuleDescription.vue?vue&type=script&lang=js&"
export * from "./ModuleDescription.vue?vue&type=script&lang=js&"
import style0 from "./ModuleDescription.vue?vue&type=style&index=0&id=e198eb68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e198eb68",
  null
  
)

export default component.exports